import { render, staticRenderFns } from "./PlusCard.vue?vue&type=template&id=4c0630dc&"
import script from "./PlusCard.vue?vue&type=script&lang=js&"
export * from "./PlusCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports